<template>
    <!-- https://www.svgrepo.com/svg/501503/clear-text-formatting?edit=true -->
    <svg width="20px" height="20px" viewBox="0 0 192 192" xmlns="http://www.w3.org/2000/svg" fill="#F09A0FFF">
        <g id="SVGRepo_bgCarrier" stroke-width="0" />

        <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round" />

        <g id="SVGRepo_iconCarrier">
            <g fill="none">
                <path
                    d="M43.516 108.672a64.034 55.026 0 0 1 9.856-72.646 64.034 55.026 0 0 1 85.111-.064 64.034 55.026 0 0 1 10.004 72.631 64.034 55.026 0 0 1-82.777 17.012"
                    style="
                        fill: #f09a0fff;
                        fill-opacity: 0;
                        stroke: #f09a0fff;
                        stroke-width: 12;
                        stroke-linecap: round;
                        stroke-linejoin: round;
                        stroke-miterlimit: 6;
                        stroke-dasharray: none;
                        stroke-opacity: 1;
                    "
                />
                <path
                    d="m43.502 108.845-6.065 25.465 28.128-8.73"
                    style="
                        fill: #f09a0fff;
                        fill-opacity: 0;
                        stroke: #f09a0fff;
                        stroke-width: 12;
                        stroke-linecap: round;
                        stroke-linejoin: round;
                        stroke-opacity: 1;
                        paint-order: stroke fill markers;
                    "
                />
                <path
                    d="M81.976 63.588A14.588 14.588 0 0 1 96.564 49a14.588 14.588 0 0 1 14.587 14.588m-29.158-.198v11.596m29.172-11.42.056 11.003"
                    style="
                        fill: #f09a0fff;
                        fill-opacity: 0;
                        stroke: #f09a0fff;
                        stroke-width: 8;
                        stroke-linecap: round;
                        stroke-linejoin: round;
                        stroke-miterlimit: 6;
                        stroke-dasharray: none;
                        stroke-opacity: 1;
                        paint-order: stroke fill markers;
                    "
                />
                <ellipse
                    cx="54.659"
                    cy="162.498"
                    rx="9.323"
                    ry="9.502"
                    style="
                        fill: #f09a0fff;
                        fill-opacity: 0;
                        stroke: #f09a0fff;
                        stroke-width: 8;
                        stroke-linecap: round;
                        stroke-linejoin: round;
                        stroke-miterlimit: 6;
                        stroke-dasharray: none;
                        stroke-opacity: 1;
                        paint-order: stroke fill markers;
                    "
                />
                <ellipse
                    cx="95.592"
                    cy="162.498"
                    rx="9.323"
                    ry="9.502"
                    style="
                        fill: #f09a0fff;
                        fill-opacity: 0;
                        stroke: #f09a0fff;
                        stroke-width: 8;
                        stroke-linecap: round;
                        stroke-linejoin: round;
                        stroke-miterlimit: 6;
                        stroke-dasharray: none;
                        stroke-opacity: 1;
                        paint-order: stroke fill markers;
                    "
                />
                <ellipse
                    cx="137.185"
                    cy="162.498"
                    rx="9.323"
                    ry="9.502"
                    style="
                        fill: #f09a0fff;
                        fill-opacity: 0;
                        stroke: #f09a0fff;
                        stroke-width: 8;
                        stroke-linecap: round;
                        stroke-linejoin: round;
                        stroke-miterlimit: 6;
                        stroke-dasharray: none;
                        stroke-opacity: 1;
                        paint-order: stroke fill markers;
                    "
                />
                <path
                    d="M116.14 76.146v25.459H76.998V76.146h39.052"
                    style="
                        fill: #f09a0fff;
                        fill-opacity: 0;
                        stroke: #f09a0fff;
                        stroke-width: 8;
                        stroke-linecap: round;
                        stroke-linejoin: round;
                        stroke-miterlimit: 6;
                        paint-order: stroke fill markers;
                    "
                />
            </g>
        </g>
    </svg>
</template>

<script>
export default {
    name: "visitorClearIcon",
};
</script>

<style scoped></style>
